<template>
  <form @submit.prevent="submit">
    <base-card body-class="p-0">
      <template v-slot:header>
        <base-card-heading>
          Accrue Calculator
        </base-card-heading>
      </template>
      <div class="row">
        <div class="col m-4 pr-0">
          <base-field addon-right-icon="percent" label="Annual Interest Rate">
            <base-input v-model="payload.interestRate" numeric placeholder="interest rate" />
          </base-field>
          <base-field label="Days Accrued">
            <base-input v-model="payload.daysAccrued" numeric placeholder="days accrued" />
          </base-field>
          <base-field addon-left-icon="pound-sign" label="Cost per Share">
            <base-input v-model="payload.costPerShare" numeric placeholder="cost per share" />
          </base-field>
          <base-field addon-left-icon="pound-sign" label="Total Invested">
            <base-input v-model="payload.totalInvested" numeric placeholder="total invested" />
          </base-field>
        </div>
        <div class="col pl-0">
          <div class="bg-secondary p-4">
            <p>
              <strong>Calculate Daily Interest Rate:</strong>
            </p>
            <p>
              <pre>$interest_rate / 365</pre>
            </p>
            <p>
              <strong>Calculate Daily Accrued per Share:</strong>
            </p>
            <p>
              <pre>($share_value * $daily_interest_rate) / 100</pre>
            </p>
            <p>
              <strong>Calculate Total Accrued per Share:</strong>
            </p>
            <p class="mb-0">
              <pre>$daily_accrued_per_share * $days_accrued</pre>
            </p>
          </div>
          <div class="text-center pt-4">
            <template v-if="simulated">
              <dl class="row">
                <dt class="col-sm-6">Daily interest rate</dt>
                <dd class="col-sm-6">{{ simulated.dailyInterestRate }}</dd>

                <dt class="col-sm-6">Daily accrued per share</dt>
                <dd class="col-sm-6">{{ simulated.dailyAccruedPerShare }}</dd>

                <dt class="col-sm-6">Total shares</dt>
                <dd class="col-sm-6">{{ simulated.totalShares }}</dd>

                <dt class="col-sm-6">Total accrued per share</dt>
                <dd class="col-sm-6">{{ $formatting.toCurrency(simulated.accruedPerShare) }}</dd>

                <dt class="col-sm-6">Total accrued</dt>
                <dd class="col-sm-6">{{ $formatting.toCurrency(simulated.totalAccrued) }}</dd>
              </dl>
            </template>
            <template v-else>
              <p>
                Simulate to see calculation.
              </p>
            </template>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <div class="text-right">
          <base-button secondary submit>
            Simulate
          </base-button>
        </div>
      </template>
    </base-card>
  </form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'InvestmentToolAccrue',

  data: () => ({
    payload: {
      interestRate: 10,
      daysAccrued: 365,
      costPerShare: 100,
      totalInvested: 2000
    },
    simulated: null
  }),

  methods: {
    submit () {
      this.simulate(this.payload)
        .then(simulated => {
          this.simulated = simulated
        })
        .catch(err => this.$flash.failure(err))
    },

    ...mapActions({
      simulate: 'core/shares/simulate-accrued'
    })
  }
}
</script>
